angular.module("labApp").factory("LabResultsSummaryResource", function ($resource) {
    return $resource('/api/v1.0/lab/results-summary/');
});
